import React from 'react';
import logo from './watermark_only.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="Barry King Live" alt="logo" />
      </header>
    </div>
  );
}

export default App;
